import { userService } from '../../helpers/authservice/user.service';
import router from '../../router/index'
import Swal from "sweetalert2";

const user = JSON.parse(localStorage.getItem('user'));


const adminstatus = user ? JSON.parse(localStorage.getItem('user')).role === "Admin" ? true : false : false;

export const state = user
    ? { statusAdmin: {loggedadmin: adminstatus}, status: { loggeduser: true }, user }
    : { statusAdmin: {}, status: {}, user: null };

export const actions = {
    loginAD({ dispatch, commit }, { token }) {
        userService.loginAD(token)
        .then(
            user => {
                if(user.role === "Admin"){
                    commit('loginAdminSuccess', user);
                }
                commit('loginSuccess', user);
                router.push({ name: 'default' });
            },
            error => {
                Swal.fire("Error!", error, "warning");
                commit('loginFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    
    login({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });
        userService.login(email, password)
            .then(
                user => {
                    if(user.role === "Admin"){
                        commit('loginAdminSuccess', user);
                    }
                    commit('loginSuccess', user);
                    router.push({ name: 'default' });
                },
                error => {
                    Swal.fire("Error!", error, "warning");
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
    registeruser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    dispatch('notification/success', 'Registration successful', { root: true });
                    router.push('/login');
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },
};

export const getters = {
    user: state => state.user,
    status: state => state.status,
    loggedInAdmin(state) {
        return !!state.statusAdmin.loggedadmin
    }
};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    loginAdminSuccess(state, user) {
        state.statusAdmin = { loggedadmin: true };
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    },
};

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401 || response.status === 422) {
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

